import get from 'lodash/get';
import { useQuery } from '../../../tools/useQuery';
import MPP_ATTESTATION_TYPE_QUERY from './MppAttestationTypeQuery.gql';

const parseResult = (result) => {
  const initialState = {};

  const attestationType = get(result, 'mpp.getMppAttestationType');

  return {
    ...initialState,
    ...attestationType,
  };
};

export const useMppAttestationTypeQuery = (options) => {
  const [queryResult, queryAction] = useQuery(MPP_ATTESTATION_TYPE_QUERY, {
    ...options,
    requestPolicy: 'no-cache',
    onCompleted: (result) => {
      options.onCompleted(parseResult(result.body.data));
    },
  });
  const parsedResult = {
    ...queryResult,
    data: parseResult(queryResult.data),
  };

  return [parsedResult, queryAction];
};
